import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl';
import * as UploadsActions from '../uploads'

interface UploadPromoParams {
    file: File;
    filename: string;
    onProgress?: (progress: number) => void;
    promoId: number;
    uploadId: string;
}

export type UploadPromoAction = UploadsActions.UploadFileV3Action

function uploadPromo({
    file,
    filename,
    onProgress,
    promoId,
    uploadId,
}: UploadPromoParams) {
    return UploadsActions.uploadFileV3(
        { file, filename, uploadId },
        {
            basePath: `${HUBBLE_API_TOKEN}/promos/${promoId}`,
            onProgress
        },
    )
}

export default uploadPromo
